import {
  Configuration,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { isLocalHost } from '../helpers/environmentHelper';

const clientId = isLocalHost()
  ? process.env.REACT_APP_SBX_AD_B2C_CLIENT_ID
  : process.env.REACT_APP_PRD_AD_B2C_CLIENT_ID;

const tenantName = isLocalHost()
  ? process.env.REACT_APP_SBX_AD_B2C_TENANT_NAME
  : process.env.REACT_APP_PRD_AD_B2C_TENANT_NAME;

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? '',
    authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1_signupsignin`,
    knownAuthorities: [`${tenantName}.b2clogin.com`],
    redirectUri: isLocalHost()
      ? 'http://localhost:3000/dashboard'
      : 'https://app.elora.lu/dashboard',
  },
  cache: {
    cacheLocation: 'localStorage', // This can also be "localStorage"
    storeAuthStateInCookie: false, // Set to true if you're having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        console.log(message);
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Verbose,
    },
  },
};

const apiScope = `https://${tenantName}.onmicrosoft.com/${clientId}/access_as_user`;

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', apiScope],
  authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1_signupsignin`,
};

export const msalInstance = new PublicClientApplication(msalConfig);
